import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { FunctionComponent } from 'react';

interface LikeAdDialogProps {
  open: boolean;
  onClose: () => void;
  onWatch: () => void;
}

export const LikeAdDialog: FunctionComponent<LikeAdDialogProps> = ({
  open,
  onClose,
  onWatch,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="like-ad-dialog-title"
      aria-describedby="like-ad-dialog-description"
    >
      <DialogTitle id="like-ad-dialog-title">
        {'Pause publicitaire'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="like-ad-dialog-description">
          {
            'Vous avez épuisé tout votre stock de likes, regardez cette pub avant de continuer.'
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fermer</Button>
        <Button onClick={onWatch} autoFocus variant="contained">
          Regarder
        </Button>
      </DialogActions>
    </Dialog>
  );
};
